<template>
  <div class="classify-nav">
    <div class="cn-wrapper">
      <div class="classify" :class="!isHomePath?'hide':''" @click="classifyMouse(true)" @mouseenter="classifyMouse(true)"
           @mouseleave="classifyMouse(false)">
        <span class="title">服务与产品</span>
        <div class="c-layer">
          <div class="h-line"></div>
          <div class="cl-main">
            <div v-for="(v,i) in classifyProductNameList" :key="i">
              <div class="cll-item" v-if="v.children && v.children.length > 0">
                <div class="item-left">
                  <el-image v-if="v.icon" :src="v.icon"></el-image>
                  <div class="name">{{ v.name }}</div>
                </div>
                <i class="el-icon-arrow-right"></i>
                <div class="other-wrapper">
                  <div class="ow-item" v-for="(m,n) in v.children" :key="n">
                    <div class="owi-left">
                      <div class="v-line"></div>
                      <div class="ow-name"
                           @click.stop="clickClassify(`/product/classify?classifyId=${v.classifyId}&name=${m.name}&tClassifyId=${m.classifyId}`)">
                        {{ m.name }}
                      </div>
                    </div>
                    <div class="product-wrapper" v-if="m.children && m.children.length > 0">
                      <div class="pw-item" v-for="(o,p) in m.children" :key="p"
                           @click.stop="clickClassify(`/product/detail?productId=${o.productId}&name=${v.name}&classifyId=${v.classifyId}&source=list`)">
                        {{ o.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav">
        <div class="nav-item" @click="$router.push('/')">首页</div>
        <div class="nav-item" @click="$router.push('/product/classify?classifyId=1&name=我要检测')">我要检测</div>
        <div class="nav-item" @click="$router.push('/product/classify?classifyId=2&name=我要认证')">我要认证</div>
        <div class="nav-item" @click="$router.push('/product/classify?classifyId=3&name=考证/培训')">考证/培训</div>
        <div class="nav-item" @click="$router.push('/inquiry')">我要查询</div>
        <div class="nav-item">
          <el-dropdown @command="onJoinsClick">
            <span>我要加盟</span>
            <el-dropdown-menu>
              <el-dropdown-item command="1">城市加盟</el-dropdown-item>
              <el-dropdown-item command="2">实验室加盟</el-dropdown-item>
              <el-dropdown-item command="3">认证机构加盟</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="nav-item" @click="$router.push('/qrcode')">二维码生成器</div>
        <div class="nav-item">
          <el-dropdown @command="onAboutClick">
            <span>关于我们</span>
            <el-dropdown-menu>
              <el-dropdown-item command="/about">公司简介</el-dropdown-item>
              <el-dropdown-item command="/about/wtic">全球检测认证机构联盟(WTIC)</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="nav-item">
          <el-dropdown @command="onNewsClick">
            <span>新闻资讯</span>
            <el-dropdown-menu>
              <el-dropdown-item command="1">行业新闻</el-dropdown-item>
              <el-dropdown-item command="2">城市新闻</el-dropdown-item>
              <el-dropdown-item command="3">通知公告</el-dropdown-item>
              <el-dropdown-item command="4">最新活动</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toTreeData } from "@/utils/common";

export default {
  name: "ClassifyNav",
  data () {
    return {
      classifyProductNameList: []
    }
  },
  created () {
    this.getClassifyProductNameList()
  },
  computed: {
    isHomePath () {
      return ['/', '/home'].indexOf(this.$route.path) !== -1
    }
  },
  methods: {
    /**
     * 获取分类产品名称列表
     */
    getClassifyProductNameList () {
      this.$request.get('/Product/classifyProductNameList')
          .then(res => {
            if (res.code === 0) {
              this.classifyProductNameList = toTreeData({
                data: res.data,
                idField: 'classifyId',
                parentIdField: 'parentId'
              })
            }
          })
    },
    /**
     * 关于我们下拉点击
     * @param command
     */
    onAboutClick (command) {
      this.$router.push(command)
    },
    /**
     * 我要加盟下拉点击
     * @param command
     */
    onJoinsClick (command) {
      this.$router.push(`/joins?classifyId=${command}`)
    },
    /**
     * 新闻资讯下拉点击
     * @param command
     */
    onNewsClick (command) {
      this.$router.push(`/news?classifyId=${command}`)
    },
    /**
     * 鼠标移入移出服务与产品
     * @param type
     */
    classifyMouse (type) {
      this.classifyToggleClass('hover', type)
    },
    /**
     * 点击服务与产品选项时，关闭弹窗
     * @param url
     */
    clickClassify (url) {
      this.classifyToggleClass('hover', false)
      this.$router.push(url)
    },
    /**
     * 处理class
     * @param cls
     * @param type
     */
    classifyToggleClass (cls, type) {
      let box = document.getElementsByClassName('classify')[0];

      let className = box.className.trim().split(' ').filter((d) => d !== '');
      if (type) {
        className.push(cls);
      } else {
        className = className.filter((d) => d !== cls);
      }
      box.className = className.join(' ');
    }
  }
}
</script>

<style scoped lang="scss">
.el-dropdown-menu__item {
  white-space: nowrap;
}

::v-deep(.el-dropdown-menu .el-dropdown-menu__item) {
  color: #6C6C6C;
  font-size: 15px;
}

.classify-nav {
  width: 100%;
  background-color: #F1F5FF;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 5px solid #1464FF;
  padding-top: 10px;

  .cn-wrapper {
    width: 1200px;
    height: 56px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    white-space: nowrap;

    .classify {
      position: relative;
      width: 204px;
      height: 100%;
      background-color: #1464FF;
      border-radius: 8px 8px 0 0;
      line-height: 56px;
      text-align: center;
      color: #FFFFFF;
      cursor: pointer;
      z-index: 9;

      &.hide {
        .c-layer {
          display: none;
        }

        &.hover .c-layer, &.hover .other-wrapper {
          display: block;
          box-shadow: 0 1px 7px rgba(136, 147, 169, 0.24);
        }
      }

      .c-layer {
        overflow: hidden;

        .h-line {
          width: 100%;
          height: 5px;
          background-color: #1464FF;
        }

        .cl-main {
          width: 204px;
          height: 396px;
          background-color: #FFFFFF;
          padding: 25px 0 20px 0;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          border-radius: 0 0 0 8px;

          .cll-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;

            &:hover {
              .name, i {
                color: #1464FF;
              }

              .other-wrapper {
                display: block;
              }
            }

            .item-left {
              display: flex;
              flex-direction: row;
              align-items: center;

              .el-image {
                width: 20px;
                height: 20px;
                margin-right: 5px;
              }

              .name {
                line-height: 50px;
              }
            }

            .name, i {
              color: #2D2D2D;
              font-size: 14px;
              font-weight: bold;
            }

            .other-wrapper {
              top: 62px;
              right: -996px;
              position: absolute;
              width: 996px;
              height: 396px;
              background-color: #FFFFFF;
              z-index: 9;
              border-left: 1px solid #D7D7D7;
              border-radius: 0 0 8px 0;
              overflow-y: auto;
              padding: 25px 20px 20px;
              display: none;

              .ow-item {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                margin-bottom: 20px;

                &:last-child {
                  margin-bottom: 0;
                }

                .owi-left {
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  .v-line {
                    width: 4px;
                    height: 20px;
                    background-color: #1464FF;
                  }

                  .ow-name {
                    color: #2D2D2D;
                    font-weight: bold;
                    font-size: 14px;
                    margin-left: 4px;
                  }
                }

                .product-wrapper {
                  flex: 1;
                  width: 0;
                  display: flex;
                  flex-direction: row;
                  flex-wrap: wrap;
                  border-bottom: 1px dashed #E2E2E2;
                  padding-bottom: 20px;
                  margin-left: 40px;

                  .pw-item {
                    margin: 0 20px 10px 0;
                    color: #6C6C6C;
                    font-size: 14px;

                    &:hover {
                      color: #1464FF;
                      text-decoration: underline;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .nav {
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-left: 10px;

      .nav-item {
        padding: 6px 16px;
        color: #2D2D2D;
        cursor: pointer;
        border-radius: 2px 8px;
        transition: background-color .3s;

        .el-dropdown {
          color: #2D2D2D;
          font-size: 18px;
          font-weight: bold;
        }

        &:hover {
          background-color: #CDDEFF;
        }
      }
    }
  }
}
</style>